import createReactComponent from '../createReactComponent';
export default createReactComponent('bluetooth', 'IconBluetooth', [
  ['path', { d: 'M7 8l10 8l-5 4l0 -16l5 4l-10 8', key: 'svg-0' }],
]);
